/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const a = {};
function t(c, o, e) {
  a[c] = { value: o, hsva: e };
}
function n(c, o, e) {
  a[c] = { value: o, rgba: e };
}
function r(c, o, e) {
  a[c] = { value: o, hex: e };
}
function i(c) {
  delete a[c];
}
function u(c, o) {
  if (c) {
    const e = a[c];
    return e && e.value === o ? e.hex : void 0;
  } else
    return;
}
function h(c, o) {
  if (c) {
    const e = a[c];
    return e && e.value === o ? e.hsva : void 0;
  } else
    return;
}
function v(c, o) {
  if (c) {
    const e = a[c];
    return e && e.value === o ? e.rgba : void 0;
  } else
    return;
}
export {
  r as cacheHex,
  t as cacheHsva,
  n as cacheRgba,
  u as getCachedHex,
  h as getCachedHsva,
  v as getCachedRgba,
  i as removeCachedColor
};
